import api from "../../../api/axios";
import { buildLocalDayWindow, buildSummaryQueryParams } from "../lib/dayWindow";

export const fetchDashboardSummary = (params, options = {}) => {
  const dayWindow = params?.day_start && params?.day_end
    ? params
    : buildSummaryQueryParams(buildLocalDayWindow());
  return api
    .get("/crm/dashboard/summary/", {
      params: dayWindow,
      signal: options.signal,
    })
    .then((res) => res.data);
};
